<template>
  <div></div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: "dynamicHome",
  computed: {
    ...mapGetters(['isInvestor'])
  },
  created() {
    if (this.isInvestor) {
      this.$router.push({ path: "investor" });
      return;
    }

    const route = process.env.VUE_APP_HOME_ROUTE || "";

    if (route) {
      this.$router.push({ path: route });
    } else {
      this.$router.push({ path: "portfolio" });
    }

  }
};
</script>

<style scoped></style>
